'use strict'
module.exports = {
  NODE_ENV: '"production"',
  VUE_APP_BACKEND_URL: '"https://csa-api.production.mobiviadatabase.com"',
  VUE_APP_GOOGLE_TOKEN: '"270254159109-uivsnbr1fvbjnsqm8b057g4h3ghgpsgp.apps.googleusercontent.com"',
  BROWSER_LANGUAGE: null
}


//////////////////
// WEBPACK FOOTER
// ./config/prod.env.js
// module id = rBKV
// module chunks = 4